import { Box, Typography } from "@mui/material";
import React from "react";
import { CustomPaper } from "../../../../resume-intelligence/Style";

function Recommendations() {
  // Static content for recommendations
  const staticRecommendations = [
    "We recommend you double check the candidate's willingness to relocate and ask them about her depth of expertise with SQL.",
    "We recommend you conduct an assessment to check candidate's fluency with design principles.",
    "As we couldnt assess information around candidate's education and visa status, we recommend sending a chatbot to procure missing information from the candidate so we can give you a better score",
  ];

  return (
    <Box marginTop={"0.5rem"}>
      {staticRecommendations?.map((item, index) => (
        <CustomPaper
          variant="outlined"
          width="100%"
          padding={"12px"}
          marginBottom={"8px"}
          display={"flex"}
          alignItems={"start"}
          key={index}
        >
          <Typography fontSize={"16px"} fontWeight={500} color={"#667085"}>
            {item}
          </Typography>
        </CustomPaper>
      ))}
    </Box>
  );
}

export default Recommendations;
